import { Show } from 'solid-js'
import { m } from '~/paraglide/messages'

type Props = {
  current: number
  total: number
  state: 'empty' | 'partial' | 'full' | 'complete' | 'loading'
}

export function DailyProgressBar(props: Props) {
  const fillPct = () => {
    if (props.total <= 0) return 0
    if (props.state === 'empty' || props.state === 'loading') return 0
    return Math.min(100, Math.max(0, (props.current / props.total) * 100))
  }

  const showFill = () => props.state !== 'empty' && props.state !== 'loading'

  const label = () =>
    props.state === 'complete'
      ? m.monthlytask_claimed()
      : `${props.current}/${props.total}`

  return (
    <div
      class="relative flex w-full flex-col items-center"
      data-state={props.state}
    >
      <div class="h-[30px] w-full shrink-0 rounded-[8px] border-4 border-white bg-track" />
      <Show when={showFill()}>
        <div
          class="absolute left-[4px] top-1/2 h-[22px] -translate-y-1/2 rounded-[4px] bg-progress-yellow shadow-[inset_0_-1.5px_0_rgba(0,0,0,0.06)] transition-[width] duration-500 ease-out"
          style={{ width: `${fillPct()}%` }}
        />
      </Show>
      <Show when={props.state !== 'loading'}>
        <p class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 whitespace-nowrap text-center text-sm font-semibold leading-[20px] text-black/30">
          {label()}
        </p>
      </Show>
    </div>
  )
}
